module.exports = __webpack_public_path__ + "static/media/2DGACM11.c011f1fc.jpg";